import React, { Component } from "react";
import axios from "axios";
import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Checkbox } from "primereact/checkbox";
import { Panel } from "primereact/panel";
import { AutoComplete } from "primereact/autocomplete";
import "primeicons/primeicons.css";
import Server from "./../Server.js";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

import { connect } from "react-redux";
import { max } from "moment-jalaali";
import { Loader } from "rsuite";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Multiselect } from "multiselect-react-dropdown";

class UsersPass extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      layout: "list",
      dashData:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.data
          ? this.props.location.state.data
          : [],
      dashList:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.list
          ? this.props.location.state.list
          : [],
      NewFactors:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.NewFactors
          ? this.props.location.state.NewFactors
          : null,
      NewUsers:
        this.props &&
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.NewUsers
          ? this.props.location.state.NewUsers
          : null,
      GridDataUsers: [],
      GridDataFactors: [],
      visibleDialog: false,
      selectedId: null,
      selectedUser: null,
      username: null,
      pass: null,
      pass2: null,
      oldPass: "",
      HasError: null,
      loading: 0,
      limit: 10,
      skip: 0,
      count: 0,
      first: 0,
      systemId: this.props.systemId || localStorage.getItem("systemId"),
    };
    this.toast = React.createRef();

    this.onHide = this.onHide.bind(this);
    this.selectedUserChange = this.selectedUserChange.bind(this);
    this.handleChangePass = this.handleChangePass.bind(this);
    this.handleChangePass2 = this.handleChangePass2.bind(this);

    this.changePass = this.changePass.bind(this);
  }

  changePass(del, id) {
    let that = this;
    if (!this.state.pass2 || !this.state.pass) {
      that.toast.current.show({
        severity: "warn",
        summary: "هشدار",
        detail: (
          <div>
            <span>کلمه عبور نباید خالی باشد</span>
          </div>
        ),
        life: 8000,
      });

      return;
    } else if (this.state.pass != this.state.pass2) {
      that.toast.current.show({
        severity: "warn",
        summary: "هشدار",
        detail: (
          <div>
            <span>کلمه عبور و تکرار آن متفاوت اند</span>
          </div>
        ),
        life: 8000,
      });

      return;
    }
    this.setState({
      HasError: null,
    });
    this.setState({
      loading: 1,
    });

    let param = {
      token: localStorage.getItem("api_token"),
      _id: this.state.selectedId,
      username: this.state.username,
      pass: this.state.pass,
      oldPass: this.state.oldPass,
      systemId: this.state.systemId,
    };
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
      });
      if (response.data.error)
        that.toast.current.show({
          severity: "error",
          summary: "خطا",
          detail: (
            <div>
              <span>{response.data.result}</span>
            </div>
          ),
          life: 8000,
        });
      else {
        that.toast.current.show({
          severity: "success",
          summary: "پیغام موفقیت",
          detail: (
            <div>
              <span>عملیات با موفقیت انجام شد</span>
            </div>
          ),
          life: 8000,
        });

        that.GetUsers();
        that.setState({
          visibleDialog: false,
          pass: "",
          pass2: "",
          oldPass: "",
        });
      }
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطا",
        detail: (
          <div>
            <span>عملیات انجام نشد</span>
          </div>
        ),
        life: 8000,
      });
    };
    this.Server.send("AdminApi/changePass", param, SCallBack, ECallBack);
  }

  handleChangePass(event) {
    this.setState({ pass: event.target.value });
  }
  handleChangePass2(event) {
    this.setState({ pass2: event.target.value });
  }

  onHide(event) {
    this.setState({
      visibleDialog: false,
      selectedId: null,
      name: "",
      mail: "",
      creditPrice: false,
      company: "",
      level: "0",
      username: "",
      pass: "",
      pass2: "",
      address: "",
      RaymandAcc: "",
      RaymandUser: "",
      HasError: null,
      ShopId: null,
      map: null,
      status: "1",
    });
  }
  selectedUserChange(value) {
    let that = this;
    this.setState({
      selectedId: value._id,
      name: value.name,
      username: value.username,
      oldPass: value.systemOfUser[0].password,
      visibleDialog: true,
    });
  }
  componentDidMount() {
    let that = this;
    this.Server.send(
      "MainApi/checktoken",
      {
        token: localStorage.getItem("api_token"),
      },
      function (response) {
        that.setState({
          ShopUserId: response.data.authData.shopId,
        });
      },
      function (error) {
        console.log(error);
      }
    );
  }

  GetUsers() {
    let that = this;
    this.setState({
      loading: 1,
    });

    let param = {
      token: localStorage.getItem("api_token"),
      ShopId: this.state.ShopUserId,
      userId: this.state.SearchValue ? this.state.SearchValue : null,
      GetAll: 1,
      systemId: this.state.systemId,
      limit: this.state.limit,
      skip: this.state.skip,
    };
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
      });
      response.data.result.map(function (v, i) {
        const systemOfUser = v.systemOfUser[0];
        if (systemOfUser.level == "0") {
          v.level = "کاربر";
        } else {
          v.level = "مدیر / کارمند";
        }
        if (systemOfUser.status == "1") {
          v.status = "فعال";
        } else {
          v.status = "غیر فعال";
        }
        v.Radif = i + 1;
        v.edit = (
          <button
            className="btn btn-info irsans"
            onClick={() => that.selectedUserChange(v)}
          >
            ویرایش
          </button>
        );
      });
      that.setState({
        GridDataUsers: response.data.result,
        count: response.data.count,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/getuser", param, SCallBack, ECallBack);
  }

  rowClass(data) {
    return {
      "row-highlight1": data.level != 1,
    };
  }

  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          _id={brand._id}
        >
          <div className="col-8" _id={brand._id} style={{ textAlign: "right" }}>
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              _id={brand._id}
            >
              <span style={{ whiteSpace: "pre-wrap" }} _id={brand._id}>
                {brand.name}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }

  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });
    let param = {
      system: this.state.systemId,
      isMainSystem: true,
      title: event.query,
      table: "users",
      name: ["name", "username", "RaymandAcc", "RaymandUser"],
    };

    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({ _id: v._id, name: v.name });
      });
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {};
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack);
  }

  render() {
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={() => this.changePass()}
          style={{ width: "200px", marginTop: "5px", marginBottom: "5px" }}
        >
          اعمال
        </button>
      </div>
    );

    return (
      <div style={{ direction: "rtl" }}>
        <div className="row justify-content-center mt-2">
          <Toast
            ref={this.toast}
            position="top-left"
            style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
          />
          <div className="row">
            <div
              className="col-lg-6 col-12 mb-5"
              style={{ background: "#fff", textAlign: "right", marginTop: 20 }}
            >
              <AutoComplete
                placeholder="بخشی از نام / شماره موبایل / شناسه کاربری / شماره حساب  را جستجو کنید"
                style={{ width: "100%" }}
                onChange={(event) => {
                  this.setState({ searchName: event.value, SearchValue: null });
                }}
                itemTemplate={this.itemTemplate.bind(this)}
                value={this.state.searchName}
                onSelect={(event) => {
                  this.setState(
                    {
                      limit: 10,
                      skip: 0,
                      count: 0,
                      first: 0,
                      SearchValue: event.value._id,
                      searchName: event.value.name,
                    },
                    () => {
                      this.GetUsers();
                    }
                  );
                }}
                suggestions={this.state.brandSuggestions}
                completeMethod={this.suggestBrands.bind(this)}
              />
            </div>
            <div
              className="col-lg-6 col-12 mb-5"
              style={{ background: "#fff", textAlign: "right", marginTop: 20 }}
            >
              <button
                className="btn btn-info irsans"
                onClick={() => {
                  this.setState(
                    {
                      limit: 10,
                      skip: 0,
                      count: 0,
                      first: 0,
                    },
                    () => {
                      this.GetUsers();
                    }
                  );
                }}
              >
                جستجو
              </button>
            </div>
          </div>
          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="مدیریت رمز عبور کاربران"
              style={{
                textAlign: "right",
                marginBottom: 50,
                fontFamily: "yekan",
              }}
            >
              <DataTable
                rowClassName={this.rowClass}
                rows={this.state.limit}
                lazy
                onPage={(event) => {
                  console.log(event);
                  this.setState(
                    {
                      skip: event.page + 1,
                      first: event.first,
                    },
                    () => {
                      this.GetUsers();
                    }
                  );
                }}
                loading={this.state.loading}
                totalRecords={this.state.count}
                first={this.state.first}
                paginator={true}
                responsive
                ref={(el) => (this.dt = el)}
                value={this.state.GridDataUsers}
                selectionMode="single"
                selection={this.state.selectedUser}
                onSelectionChange={(e) => this.selectedUserChange(e.value)}
              >
                <Column
                  field="username"
                  header="نام کاربری"
                  className="irsans"
                  style={{ textAlign: "right" }}
                  filterMatchMode="contains"
                />
                <Column
                  field="name"
                  header="نام"
                  className="irsans"
                  style={{ textAlign: "right" }}
                  filterMatchMode="contains"
                />
                <Column
                  field="status"
                  header="وضعیت"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
              </DataTable>
            </Panel>
          </div>
        </div>
        <Dialog
          header="ویرایش / مشاهده رمز عبور"
          visible={this.state.visibleDialog}
          width="800px"
          footer={footer}
          minY={70}
          maxY={400}
          onHide={this.onHide}
          maximizable={true}
        >
          <form
            style={{
              maxWidth: 800,
              maxHeight: 450,
              marginBottom: 10,
              maxWidth: 1000,
            }}
          >
            <div className="row">
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    disabled
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.username}
                    name="username"
                    onChange={this.handleChangeUsername}
                    required="true"
                  />
                  <label>نام کاربری</label>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    disabled
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.name}
                    name="name"
                    onChange={this.handleChangeName}
                    required="true"
                  />
                  <label>نام و نام خانوادگی</label>
                </div>
              </div>
              <div className="col-lg-12 col-12">
                <div className="group" style={{ marginBottom: 20 }}>
                  <label>رمز عبور جاری : {this.state.oldPass}</label>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="password"
                    value={this.state.pass}
                    name="pass"
                    onChange={this.handleChangePass}
                    required="true"
                  />
                  <label>رمز عبور جدید</label>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="password"
                    value={this.state.pass2}
                    name="pass2"
                    onChange={this.handleChangePass2}
                    required="true"
                  />
                  <label>تکرار رمز عبور جدید</label>
                </div>
              </div>
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(UsersPass);
